import { render, staticRenderFns } from "./MedicalCard.vue?vue&type=template&id=1fc1ba0d&scoped=true"
import script from "./MedicalCard.vue?vue&type=script&lang=js"
export * from "./MedicalCard.vue?vue&type=script&lang=js"
import style0 from "./MedicalCard.vue?vue&type=style&index=0&id=1fc1ba0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc1ba0d",
  null
  
)

export default component.exports